import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
const Products = lazy(() => import("../pages/products/page"));
const ProductDetail = lazy(() => import("../pages/product-detail/page"));
const Cart = lazy(() => import("../pages/cart/page"));
const Wishlist = lazy(() => import("../pages/wishlist/page"));
const Compare = lazy(() => import("../pages/compare/page"));
const Login = lazy(() => import("../pages/login/page"));
const Dashboard = lazy(() => import("../pages/dashboard/page"));
const Loyalty = lazy(() => import("../pages/loyalty/page"));
const Notifications = lazy(() => import("../pages/notifications/page"));
const Checkout = lazy(() => import("../pages/checkout/page"));
const OrderConfirmation = lazy(
  () => import("../pages/order-confirmation/page")
);
const Orders = lazy(() => import("../pages/orders/page"));
const Profile = lazy(() => import("../pages/profile/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

// Loading component
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-gray-600">Loading...</p>
    </div>
  </div>
);

// Wrapper component for Suspense
const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingFallback />}>{children}</Suspense>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <SuspenseWrapper>
        <Home />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/products",
    element: (
      <SuspenseWrapper>
        <Products />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/product/:id",
    element: (
      <SuspenseWrapper>
        <ProductDetail />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/cart",
    element: (
      <SuspenseWrapper>
        <Cart />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/wishlist",
    element: (
      <SuspenseWrapper>
        <Wishlist />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/compare",
    element: (
      <SuspenseWrapper>
        <Compare />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/login",
    element: (
      <SuspenseWrapper>
        <Login />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <SuspenseWrapper>
        <Dashboard />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/loyalty",
    element: (
      <SuspenseWrapper>
        <Loyalty />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/notifications",
    element: (
      <SuspenseWrapper>
        <Notifications />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/checkout",
    element: (
      <SuspenseWrapper>
        <Checkout />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/order-confirmation",
    element: (
      <SuspenseWrapper>
        <OrderConfirmation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/orders",
    element: (
      <SuspenseWrapper>
        <Orders />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/profile",
    element: (
      <SuspenseWrapper>
        <Profile />
      </SuspenseWrapper>
    ),
  },
  {
    path: "*",
    element: (
      <SuspenseWrapper>
        <NotFound />
      </SuspenseWrapper>
    ),
  },
];

export default routes;
